<template>
    <div class="wellness-ring">
        <div class="ring-wrap">
            <svg viewBox="0 0 72 72" fill="none">
                <circle cx="36" cy="36" r="28" :stroke="trackColor" stroke-width="6" fill="none" />
                <circle cx="36" cy="36" r="28" :stroke="color" stroke-width="6" fill="none"
                    stroke-linecap="round" :stroke-dasharray="circumference" :stroke-dashoffset="offset"
                    transform="rotate(-90 36 36)" class="ring-progress" />
            </svg>
            <div class="ring-center">
                <v-icon v-if="icon" size="13" :color="color">{{ icon }}</v-icon>
                <span class="ring-score" :style="{ color }">{{ display }}</span>
            </div>
        </div>
        <span class="ring-label">{{ label }}</span>
    </div>
</template>

<script>
const CIRCUMFERENCE = 175.9

export default {
    name: "WellnessRing",
    props: {
        value: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 10,
        },
        label: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: null,
        },
    },
    computed: {
        circumference() {
            return CIRCUMFERENCE
        },
        clamped(vm = this) {
            return Math.max(0, Math.min(vm.value, vm.max))
        },
        offset(vm = this) {
            return CIRCUMFERENCE * (1 - vm.clamped / vm.max)
        },
        display(vm = this) {
            return vm.value ? Number(vm.value).toFixed(1) : '—'
        },
        color(vm = this) {
            if (!vm.value) return vm.$vuetify.theme.currentTheme.txtMuted
            if (vm.value >= 7) return '#009966'
            if (vm.value >= 5) return vm.$vuetify.theme.currentTheme.primary
            return vm.$vuetify.theme.currentTheme.error
        },
        trackColor(vm = this) {
            return vm.$vuetify.theme.currentTheme.surface2
        },
    },
}
</script>

<style scoped>
.wellness-ring {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
}

.ring-wrap {
    position: relative;
    width: 60px;
    height: 60px;
}

.ring-wrap svg {
    width: 60px;
    height: 60px;
}

.ring-progress {
    transition: stroke-dashoffset 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.ring-center {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1px;
}

.ring-score {
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
}

.ring-label {
    font-size: 9px;
    font-weight: 500;
    color: var(--v-txtSecondary-base);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    text-align: center;
}
</style>
